import React from "react";
import ReportingAnalytics from "../component/ReportingAnalytics";

const ReportingAndAnalytics = () => {
  return (
    <>
      <ReportingAnalytics />
    </>
  );
};

export default ReportingAndAnalytics;
